import { TFunction } from "i18next";

import { LANGUAGE_LABEL } from "../configs/configs";
import { getLanguageI18nKey } from "./getLanguageI18nKey";

export const REQUIRED_KIOSK_LANGUAGE_CODES = ["km-KH"] as const;

export const ensureSupportedKioskLanguageCodes = (languageCodes: string[] = []): string[] => {
    return Array.from(new Set([...languageCodes, ...REQUIRED_KIOSK_LANGUAGE_CODES]));
};

export const getLanguageDisplayLabel = (languageCode: string, t?: TFunction): string => {
    const i18nKey = getLanguageI18nKey(languageCode);
    const translated = t?.(i18nKey);

    if (translated && translated !== i18nKey) {
        return translated;
    }

    return LANGUAGE_LABEL[languageCode as keyof typeof LANGUAGE_LABEL] || languageCode;
};
